import { render, staticRenderFns } from "./ScannedItemsTable.vue?vue&type=template&id=03767cae&scoped=true"
import script from "./ScannedItemsTable.vue?vue&type=script&lang=js"
export * from "./ScannedItemsTable.vue?vue&type=script&lang=js"
import style0 from "./ScannedItemsTable.vue?vue&type=style&index=0&id=03767cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03767cae",
  null
  
)

export default component.exports